/**
 * Из объекта Date в строку YYYY-MM-DD
 * пример: "2024-09-05"
 * @param date {Date} - исходная дата
 * @return {string} "2024-09-05"
 */
export const getIsoDate = (date: Date): string => {
  return date.toISOString().slice(0, 10);
};

/**
 * Возвращает текущую дату в формате "2024-09-05"
 * @return {string} "2024-09-05"
 */
export const getCurrentIsoDate = (): string => {
  return getIsoDate(new Date());
};

/**
 * Из объекта Date в строку DD.MM.YYYY
 * пример: "06.09.2024"
 * @param date {Date} - исходная дата
 * @return {string} - пример: "06.09.2024"
 */
export const getRuDate = (date: Date): string => {
  return date.toLocaleString("en-GB").slice(0, 10).replaceAll("/", ".");
};
/**
 * Проверка на совпадение дат
 * @param dateA {Date}
 * @param dateB {Date}
 */
export const isEqualDate = (dateA: Date, dateB: Date) => {
  return dateA.getTime() === dateB.getTime();
};
/**
 * Возврещает объект Date на позже на указанное кол-во дней
 * @param days {number} - на сколько дней вперёд создать дату (по умолчанию 30)
 * @return {Date} текущая дата +N дней (+30 по умолчанию)
 */
export const getNextDaysDate = (days = 30): Date => {
  return new Date(Date.now() + 86_400_000 * days);
};
/**
 * Парсит строку вида DD-MM-YYYY HH:SS (30.12.2026 00:00)
 * в объект Date
 * @param date {Date}
 */
export const parseRuDate = (date: string): Date => {
  const a = date.split(".");
  [a[0], a[1]] = [a[1], a[0]];
  return new Date(a.join("."));
};
